import {h, Component} from 'preact'
import collectionService from "../service/collectionService";
import constants from "../constants";
import DragSortableList from '../lib/DragSortableList';


const PRODUCTS = ['menu', 'takeout', 'kids-menu', 'folded-menu', 'half-page-menu', 'table-tent', 'flyer', 'instagram-post','instagram-story',
    'facebook-post', 'facebook-story', 'comment-card', 'biz-card', 'loyalty-card', 'rack-card', 'gift-certificate', 'digital-menu', 'tabletop-insert',
    'poster', 'menu-mailer', 'sticker', 'label', 'sandwich-board', 'logo'];

export default class CollectionModal extends Component {
    constructor() {
        super();
        this.state = {
            isSort: false,
            product: PRODUCTS[0],
            collections: []
        };

        this.onSort = this.onSort.bind(this);
        this.changeProduct = this.changeProduct.bind(this);
        this.addCollection = this.addCollection.bind(this);
        this.save = this.save.bind(this);
        this.editCollection = this.editCollection.bind(this);
        this.removeCollection = this.removeCollection.bind(this);
        this.updateCollection = this.updateCollection.bind(this);
        this.updateCollectionField = this.updateCollectionField.bind(this);
        this.toggleSort = this.toggleSort.bind(this);
        this.getCollectionHtml = this.getCollectionHtml.bind(this);
    }

    onSort(sortedList) {
        const collections = sortedList.map(it => it.it);
        this.setState({ collections });
    }

    changeProduct(product) {
        this.setState({ product });
        this.fetchCollections(product);
    }

    addCollection() {
        const collections = [... this.state.collections, { title: '', term: '', isEdit: true}];
        this.setState({ collections });
    }

    toggleSort() {
        this.setState({ isSort: !this.state.isSort });
    }

    editCollection(collection) {
        collection.isEdit = true;
        this.setState({ collections: [...this.state.collections]});
    }

    save() {
        const collections = this.state.collections;
        collections.forEach((collection, idx) => {
            collection.product = this.state.product;
            collection.sequence = idx;
        });

        collectionService.save(collections).then(() => {
            this.props.onClose();
        });
    }

    removeCollection(collection) {
        collection.removed = true;
        this.setState({ collections: [... this.state.collections]});
    }

    updateCollection(collection) {
        collection.isEdit = false;
        this.setState({ collections: [...this.state.collections]});
    }

    updateCollectionField(collection, key, value) {
        collection[key] = value;
    }

    componentDidMount() {
        this.fetchCollections(PRODUCTS[0]);
    }

    fetchCollections(product) {
        collectionService.getForProduct(product).then(resp => {
            this.setState({ collections: resp.data});
        });
    }

    getCollectionHtml(collection) {
        return  collection.removed === true ? null :(
          <div className={'collection'}>
              <div className={'view' + (collection.isEdit ? ' hidden' : '')}>
                  <span className={'col'}>{collection.title}</span>
                  <span className={'col'}>{collection.term}</span>
                  <span className={'col act'}>
                        <a onClick={ () => this.editCollection(collection) } style="display: flex;">
                            <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-edit"}/></svg>
                        </a>
                    </span>
              </div>
              <div className={'edit' + (collection.isEdit ? '' : ' hidden')}>
                    <span className={'col'} style="padding-right: 10px;">
                        <input placeholder={'Title'}
                               style="margin-right: .5rem;"
                               value={collection.title}
                               onBlur={ (ev) => this.updateCollectionField(collection, 'title', ev.target.value)} />
                    </span>
                  <span className={'col'} style="padding-right: 10px;">
                        <input placeholder={'Search Term'}
                               style="margin-left: .5rem;"
                               value={collection.term}
                               onBlur={ (ev) => this.updateCollectionField(collection, 'term', ev.target.value)} />
                    </span>
                  <span className={'col act'}>
                        <a className="btn" onClick={ () => this.removeCollection(collection) }>Delete</a>
                        <a className="btn primary" onClick={ () => this.updateCollection(collection) }>Update</a>
                    </span>
              </div>
          </div>
        )
    }
    render (props, state) {
        let products = PRODUCTS.map(product =>
          <li>
              <a onClick={ () => this.changeProduct(product) }>{ product.replace(/-/g, ' ') }</a>
          </li>
        );

        const collections = state.collections.map(collection =>
          state.isSort ? { it: collection, content: this.getCollectionHtml(collection) } : this.getCollectionHtml(collection)
        );

        const collectionsContent = !state.isSort ? (
          collections
        ) : ( <DragSortableList items={collections} placeholder={<div />} dropBackTransitionDuration={0.3} type="vertical" onSort={ this.onSort }/>)

        return (
            <div id="collection-modal">
                <a className="btn close-it" onClick={ ()=> props.onClose() }>Close</a>
                <div className="modal save-modal">
                    <header>
                        <h3 style="line-height: 35px;">Template collections for: </h3>
                        <div className={'dropdown' + (state.isSort ? ' hidden' : '')}>
                            <a className="dropdown-toggle">{state.product.replace(/-/g, ' ')}</a>
                            <div className="dropdown-menu">
                                <div className="angle right" />
                                <ul>
                                    { products }
                                </ul>
                            </div>
                        </div>

                    </header>

                    <section className={'content' + (state.isSort ? ' sortable' : '')}>
                        <header>
                            <span className={'col'}>Title</span>
                            <span className={'col'}>Search Term</span>
                            <span className={'col act'} />
                        </header>
                        <div>{ collectionsContent }</div>
                    </section>

                    <footer>
                        <a className={'btn' + (state.isSort ? ' hidden' : '')} onClick={ this.toggleSort }>Sort</a>
                        <a className={'btn primary' + (state.isSort ? '' : ' hidden')} onClick={ this.toggleSort }>Save new order</a>

                        <a className={'btn' + (state.isSort ? ' hidden' : '')} onClick={ this.addCollection }>Add Collection</a>
                        <a className={'btn primary' + (state.isSort ? ' hidden' : '')} onClick={ this.save }>Save & Go Live</a>
                    </footer>
                </div>
            </div>
        )
    }
}
